import "core-js/modules/es.array.concat.js";
import { postReq, getReq, patchReq } from './axios';
import { allReferenceParams } from './models';
var BASE_URL = "".concat(apiUrl, "/interests-and-fees-report-request");
export var sendRequestReport = function sendRequestReport(body) {
  return postReq(BASE_URL, body);
};
export var getRequestReports = function getRequestReports(params) {
  return getReq(BASE_URL, {
    params: allReferenceParams(params)
  });
};
export var changeReportStatus = function changeReportStatus(id, body) {
  return patchReq("".concat(BASE_URL, "/").concat(id), body);
};